import { render } from "./wfm-loctext.vue?vue&type=template&id=1aac4c4b&scoped=true"
import script from "./wfm-loctext.vue?vue&type=script&lang=js"
export * from "./wfm-loctext.vue?vue&type=script&lang=js"

import "./wfm-loctext.vue?vue&type=style&index=0&id=1aac4c4b&lang=css"
import "./wfm-loctext.vue?vue&type=style&index=1&id=1aac4c4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aac4c4b"]])

export default __exports__